/**
 * Ids for the prompt sections.
 * This is mostly used to retrieve the element
 * when adding classes or binding events.
 */
export const PROMPT_IDS = {
  container: 'onesignal-slidedown-container',
  allowButton: 'onesignal-slidedown-allow-button',
  cancelButton: 'onesignal-slidedown-cancel-button',
  dialog: 'onesignal-slidedown-dialog',
}

/** General classes that are used on the prompts */
export const PROMPT_CSS_CLASSES = {
  allowButton: "onesignal-slidedown-allow-button",
  cancelButton: "onesignal-slidedown-cancel-button",
  container: "onesignal-slidedown-container",
  dialog: "onesignal-slidedown-dialog",
  reset: 'onesignal-reset',
}

/** Container class for the prompts */
export const IN_STOCK_PROMPT_CLASS = 'in-stock';
export const CONFIRMATION_PROMPT_CLASS = 'onesignal-confirmation-prompt';

/**
 * Styling override for the in stock prompts
 */
export const IN_STOCK_STYLES = `
  .${IN_STOCK_PROMPT_CLASS} .onesignal-slidedown-dialog {
    width: 450px !important;
  }
  .${IN_STOCK_PROMPT_CLASS} .slidedown-body {
    display: flex;
    justify-content: center;
    text-align: center;
  }
  .${IN_STOCK_PROMPT_CLASS} .slidedown-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 1em;
  }
  .${IN_STOCK_PROMPT_CLASS} .slidedown-button {
    font-weight: 500 !important;
    letter-spacing: 0 !important;
  }
  .${IN_STOCK_PROMPT_CLASS} .slidedown-button.primary {
    padding: 0.5em 3em !important;
  }
`;

export const CONFIRMATION_STYLES = `
  .${CONFIRMATION_PROMPT_CLASS} .onesignal-slidedown-dialog {
    width: 450px !important;
  }
  .${CONFIRMATION_PROMPT_CLASS} .slidedown-body {
    display: flex;
    justify-content: center;
    text-align: center;
  }
  .${CONFIRMATION_PROMPT_CLASS} .slidedown-body-message {
    padding: 0 !important;
  }
`;
/**
 * Fade out delay value in seconds.
 * Used for prompts that auto hide, like confirmation prompts.
 */
export const PROMPT_AUTOCLOSE_DELAY = 5;
